// @packages
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
// import { makeStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

// @styles
import styles from './styles';

// const dynamicStyle = makeStyles({
//     paper: {
//         left: '50%',
//         position: 'absolute',
//         top: (props) => props.top,
//         transform: 'translate(-50%)'
//     }
// });

const CtrlModalDialog = ({
    cancelLabel,
    className,
    classes,
    formValid,
    id,
    msg,
    okLabel,
    onConfirm,
    onHide,
    showCancel,
    style,
    title,
    visible,
    width
}) => {
    const dialogClasses = {};//style ? dynamicStyle({ top: style.top }) : {};
    const modalDialogClass = classNames(
        className,
        classes.modalDialog
    );

    const dialogContentStyle = width && { width };

    return (
        <Dialog
            className={modalDialogClass}
            classes={dialogClasses}
            id={id}
            onBackdropClick={onHide}
            onEscapeKeyDown={onHide}
            open={visible}
            scroll="body"
        >
            <DialogTitle id={`${id}-title`}>{title}</DialogTitle>
            <DialogContent id={`${id}-msg`} style={dialogContentStyle}>{msg}</DialogContent>
            { (showCancel || onConfirm)
                && (
                    <DialogActions>
                        {showCancel
                            && (
                            <Button
                                color="secondary"
                                id={`${id}-cancel-button`}
                                onClick={onHide}
                            >
                                {cancelLabel}
                            </Button>
                            )}
                        {onConfirm
                            && (
                            <Button
                                color="primary"
                                id={`${id}-ok-button`}
                                onClick={onConfirm}
                                disabled={!formValid}
                            >
                                {okLabel}
                            </Button>
                            )}
                    </DialogActions>
                )}
        </Dialog>
    );
};

CtrlModalDialog.propTypes = {
    cancelLabel: PropTypes.string,
    className: PropTypes.string,
    classes: PropTypes.object.isRequired,
    formValid: PropTypes.bool,
    id: PropTypes.string.isRequired,
    msg: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    okLabel: PropTypes.string,
    onConfirm: PropTypes.func,
    onHide: PropTypes.func.isRequired,
    showCancel: PropTypes.bool,
    style: PropTypes.object,
    title: PropTypes.string,
    visible: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

CtrlModalDialog.defaultProps = {
    cancelLabel: null,
    className: null,
    formValid: null,
    msg: null,
    okLabel: null,
    onConfirm: null,
    showCancel: true,
    style: null,
    title: null,
    visible: true,
    width: null
};

export default withStyles(styles)(CtrlModalDialog);
